import { errorToast } from "@/v2-ui/toast"
import Selector, {
  type SelectorItemProps,
} from "@/v2-backoffice-client/components/selector"
import type { UserTenantFragment } from "@/v2-backoffice-client/user/tenant/__types__/user.tenant.fragment"
import type { UserTenantTypeFragment } from "@/v2-backoffice-client/user/tenant/type/__types__/user.tenant.type.fragment"
import { useTenantUserTypeMutation } from "@/v2-backoffice-client/tenant/user/type/tenant.user.type.mutation"

export type TenantUserTypeSelectorItemProps = Omit<
  SelectorItemProps,
  "value" | "children" | "onSelect" | "onDeselect"
> & {
  type: UserTenantTypeFragment
  userTenant: UserTenantFragment
  onCompleted?(): void
}

function TenantUserTypeSelectorItem(props: TenantUserTypeSelectorItemProps) {
  const { type, userTenant, onCompleted, ...selectorItemProps } = props

  const [update, { loading, error }] = useTenantUserTypeMutation({
    onCompleted,
  })

  errorToast(error, {
    title: "Failed to update user team type",
  })

  return (
    <Selector.Item
      isLoading={loading}
      value={String(type.Code)}
      onSelect={() => {
        update({
          variables: {
            input: {
              Id: userTenant.Id,
              UserTenantTypeCode: type.Code,
            },
          },
        })
      }}
      {...selectorItemProps}
    >
      <Selector.ItemText
        primary={type.Name}
        secondary={type.Description ?? undefined}
      />
    </Selector.Item>
  )
}

export default TenantUserTypeSelectorItem
